<div class="loader d-flex flex-column justify-content-center align-items-center {{ styleClass }}">
  <div class="spinner-border" role="status"></div>
  <span *ngIf="label" class="label mt-3">{{ label }}</span>
</div>
